import { useQuery } from '@tanstack/react-query';
import type { CampaignEditRequest } from '@discovr/types';
import { campaignKeys } from '../queryKeys';
import { createCampaignDetailApi } from '../api/campaignQueries';

const api = createCampaignDetailApi();

/**
 * Every edit request for the campaign (open + resolved), newest first.
 * Powers the brand's "Changes history" toggle — disabled (enabled: false)
 * until the caller actually opens history mode, since most campaign-detail
 * views never need this list.
 */
export function useCampaignEditRequestHistoryQuery(campaignId: string, enabled: boolean) {
  return useQuery<CampaignEditRequest[]>({
    queryKey: campaignKeys.editRequestHistory(campaignId),
    queryFn: () => api.listEditRequestHistory(campaignId),
    enabled: !!campaignId && enabled,
    staleTime: 30_000,
  });
}
